module.exports = __webpack_public_path__ + "static/media/noImage.b6681619.png";